<template>
    <div>
        <a-steps class="steps" :current="1">
            <a-step title="身份认证" />
            <a-step title="重置密码" />
            <a-step title="完成" />
        </a-steps>
        <a-row style="margin: 40px 120px 20px 120px;">
        <a-col :span="24">
          <div style="margin-bottom: 30px;font-size: 16px;text-align: center;">通过手机号找回</div>
          <step-1></step-1>
          <step-2></step-2>
          <step-3></step-3>
      <a-row type="flex" justify="space-between" style="margin-top: -10px;">
        
        <p class="height-100">
          <a @click="changeToRegister()">没有账号？去注册</a>
          
        </p>
        <p class="height-50">
          <a @click="changeToLogin()">已有账号，去登录</a>
        </p>
    
    </a-row>
        </a-col>
      </a-row>
    </div>
    
    
  </template>
  

  
  <script>
  import Step1 from './forgetStep/Step1.vue'
  import Step2 from './forgetStep/Step2.vue'
  import Step3 from './forgetStep/Step3.vue'
  export default {
    components: {
      Step1,
      Step2,
      Step3
      },
    data() {
      return {
        form: this.$form.createForm(this),
        customActiveKey: 'account',
        state: {
          time: 60,
          loginBtn: false,
          // login type: 0 email, 1 username, 2 telephone
          loginType: 0,
          smsSendBtn: false
        }
      }
    },
    methods: {
      changeToLogin () {
        this.$emit('forgetToLogin')
      },
      changeToRegister(){
        this.$emit('forgetToRegister')
      }
    }
  }
  </script>
  
  <style scoped>
  .getCaptcha {
      display: block;
      width: 100%;
      height: 50px;
    }
    .steps {
    max-width: 550px;
    margin: 16px auto;
  }
  </style>